import styled, { css } from 'styled-components';
import readableTextOn from '../../../../utils/readableTextOn';

interface BadgeProps {
  color: string;
}

interface TypeOptionProps {
  selected: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 28px 32px;
  max-width: 480px;

  h1 {
    font-size: 22px;
    font-weight: 700;
    color: #4f4f4f;
  }

  h2 {
    font-size: 13px;
    font-weight: 600;
    color: #4f4f4f;
    text-transform: uppercase;
  }
`;

export const Explanation = styled.p`
  font-size: 14px;
  line-height: 1.4;
  color: #6b6b6b;
`;

export const Summary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 16px;
  border-radius: 8px;
  background: #f7f9fb;
`;

export const SummaryRow = styled.div`
  display: grid;
  grid-template-columns: 100px 1fr;
  align-items: center;
  gap: 12px;
  font-size: 13px;

  /* Só o rótulo da linha: sem o ">", a regra pegava os spans dos badges e deixava
     o texto cinza sobre a cor da gravidade. */
  > span {
    color: #9e9e9e;
    text-transform: uppercase;
    font-size: 11px;
    font-weight: 600;
  }

  strong {
    color: #4f4f4f;
  }
`;

export const Badges = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
`;

export const Badge = styled.span<BadgeProps>`
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  color: ${({ color }) => readableTextOn(color)};
  background: ${({ color }) => color};
  white-space: nowrap;
`;

export const TypeChoice = styled.div`
  display: flex;
  gap: 10px;
`;

export const TypeOption = styled.button<TypeOptionProps>`
  flex: 1;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  background: #ffffff;
  color: #6b6b6b;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  ${({ selected }) =>
    selected &&
    css`
      border-color: #2d9cdb;
      background: #eaf5fc;
      color: #2d9cdb;
    `}
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 6px;
`;
